import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BeforeAfterChart } from './BeforeAfterChartGenerator';

interface Props {
  role?: 'consumer' | 'producer';
}

export const BeforeAfterSlider: React.FC<Props> = ({ role = 'consumer' }) => {
  const { t } = useTranslation();
  const [showBefore, setShowBefore] = useState(true);

  return (
    <div className="w-full max-w-5xl mx-auto px-4 sm:px-0">
      {/* Toggle buttons above the chart */}
      <div className="flex justify-center gap-2 sm:gap-3 mb-4">
        <button
          onClick={() => setShowBefore(true)}
          className="px-3 sm:px-6 py-1.5 sm:py-3 rounded-lg font-semibold text-xs sm:text-base font-sans transition-all duration-300 shadow-lg whitespace-nowrap"
          style={{
            backgroundColor: showBefore ? '#F8BD3D' : '#ffffff',
            color: showBefore ? '#1a1a1a' : '#666666',
            border: showBefore ? '2px solid #F8BD3D' : '2px solid #e5e5e5'
          }}
        >
          {t('home.hero.beforeAfter.before')}
        </button>
        <button
          onClick={() => setShowBefore(false)}
          className="px-3 sm:px-6 py-1.5 sm:py-3 rounded-lg font-semibold text-xs sm:text-base font-sans transition-all duration-300 shadow-lg whitespace-nowrap"
          style={{
            backgroundColor: showBefore ? '#ffffff' : '#F8BD3D',
            color: showBefore ? '#666666' : '#1a1a1a',
            border: showBefore ? '2px solid #e5e5e5' : '2px solid #F8BD3D'
          }}
        >
          {t('home.hero.beforeAfter.after')}
        </button>
      </div>

      <div className="relative w-full overflow-x-auto overflow-y-hidden rounded-xl sm:rounded-2xl shadow-2xl" style={{ minHeight: 'clamp(350px, 60vh, 420px)' }}>
        <div className="absolute inset-0 transition-opacity duration-500" style={{ opacity: showBefore ? 0 : 1 }}>
          <BeforeAfterChart type="after" role={role} />
        </div>

        <div className="absolute inset-0 transition-opacity duration-500" style={{ opacity: showBefore ? 1 : 0 }}>
          <BeforeAfterChart type="before" role={role} />
        </div>
      </div>
    </div>
  );
};
